import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { createGenerateClassName } from '@material-ui/core/styles';

// import feathers in order to share it
import client from './application/client/app.client';

/** Custom imports */
import { get as getHostUrl } from './application/client/hostUrlResolver';
/** CSS imports */
import './index.css';
import Loadablecomponent from './components/LoadableComponent';

const generateClassName = createGenerateClassName();

const host = getHostUrl();

function resolveParentElement(parentIds) {
  const ids = Array.isArray(parentIds) ? parentIds : [parentIds];
  return ids.map((parentId) => document.getElementById(parentId)).find(Boolean);
}

function ConditionalRender(parentIds, componentPromiseFunction, props) {
  var parent = resolveParentElement(parentIds);

  if (parent) {
    componentPromiseFunction().then(({ default: DefaultComponent }) =>
      ReactDOM.render(<DefaultComponent host={host} generateClassName={generateClassName} {...props} />, parent),
    );
  }
}

function ConditionalRenderLoadable(parentIds, componentPromiseFunction, props) {
  var parent = resolveParentElement(parentIds);

  if (parent) {
    ReactDOM.render(
      <Loadablecomponent
        componentPromise={componentPromiseFunction().then(({ default: DefaultComponent }) => DefaultComponent)}
        host={host}
        generateClassName={generateClassName}
        {...props}
      />,
      parent,
    );
  }
}

function onSuitcaseLoaded() {
  ConditionalRender('homepageMap', () => import(/* webpackChunkName: "maps" */ './maps/HomepageMapApp'));
}

// ConditionalRender('root', () => import(/* webpackChunkName: "app" */ './App'));
ConditionalRender('suitcase', () => import(/* webpackChunkName: "suitcase" */ './Suitcase/SuitcaseApp'), {
  isWhite: false,
  onSuitcaseLoaded,
});
ConditionalRender('suitcase-white', () => import(/* webpackChunkName: "suitcase" */ './Suitcase/SuitcaseApp'), {
  isWhite: true,
});
ConditionalRenderLoadable(['orderWizard', 'wizard'], () =>
  import(/* webpackChunkName: "order-wizard" */ './Wizard/OrderWizardApp'),
);
ConditionalRender('calculator', () => import(/* webpackChunkName: "suitcase" */ './Calculator/CalculatorApp'));
// ConditionalRender('isSchengen', () => import(/* webpackChunkName: "isSchengen" */ './components/IsSchengen/IsSchengenApp'));
ConditionalRender('VisaCheckingForm', () =>
  import(/* webpackChunkName: "VisaCheckingForm" */ './components/VisaCheckingForm/VisaCheckingFormApp'),
);
// ConditionalRender('InsuranceCheckingForm', () => import(/* webpackChunkName: "InsuranceCheckingForm" */ './components/InsuranceCheckingForm/InsuranceCheckingFormApp'));
ConditionalRender('ContactForm', () =>
  import(/* webpackChunkName: "ContactForm" */ './components/ContactForm/ContactFormApp'),
);

// ConditionalRender('homepageMap', () => import(/* webpackChunkName: "maps" */ './maps/HomepageMapApp'));
ConditionalRender('schengenZoneMap', () => import(/* webpackChunkName: "maps" */ './maps/SchengenZoneMapApp'));
ConditionalRender('error404', () => import(/* webpackChunkName: "error" */ './components/errors/Error404App'));
ConditionalRender('error500', () => import(/* webpackChunkName: "error" */ './components/errors/Error500App'));

//ConditionalRender('root', () => import(/* webpackChunkName: "map" */ './maps/HomepageMapApp'));

//ReactDOM.render(<Suitcase />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js